export { default as add } from './icon_add.svg?react'
export { default as add_circle } from './icon_add_circle.svg?react'
export { default as add_file } from './icon_add_file.svg?react'
export { default as ai_bot_main } from './icon_ai_bot_main.svg?react'
export { default as ai_comment } from './icon_ai_comment.svg?react'
export { default as ai_comment_gray } from './icon_ai_comment_gray.svg?react'
export { default as ai_comment_mono } from './icon_ai_comment_mono.svg?react'
export { default as ai_comment_white } from './icon_ai_comment_white.svg?react'
export { default as ai_tutor } from './icon_ai_tutor_blue.svg?react'
export { default as ai_tutor_bot } from './icon_ai_tutor_bot.svg?react'
export { default as alarm_on } from './icon_alarm_on.svg?react'
export { default as alert_info } from './icon_alert.svg?react'
export { default as alert_error_fill } from './icon_alert_error_fill.svg?react'
export { default as answer_check } from './icon_answer_check.svg?react'
export { default as answer_correct } from './icon_answer_correct.svg?react'
export { default as answer_wrong } from './icon_answer_wrong.svg?react'
export { default as assignment } from './icon_assignment.svg?react'
export { default as assignment_turned_in } from './icon_assignment_turned_in.svg?react'
export { default as attendance } from './icon_attendance.svg?react'
export { default as bling } from './icon_bling.svg?react'
export { default as block } from './icon_block.svg?react'
export { default as book } from './icon_book.svg?react'
export { default as book_opened } from './icon_book_opened.svg?react'
export { default as book_read } from './icon_book_read.svg?react'
export { default as bookmark_fill } from './icon_bookmark_fill.svg?react'
export { default as bookmark_line } from './icon_bookmark_line.svg?react'
export { default as calendar } from './icon_calendar.svg?react'
export { default as camera } from './icon_camera.svg?react'
export { default as caution } from './icon_caution.svg?react'
export { default as chart } from './icon_chart.svg?react'
export { default as check } from './icon_check.svg?react'
export { default as check_circle } from './icon_check_circle.svg?react'
export { default as chevron_double_right } from './icon_chevron_double_right.svg?react'
export { default as chevron_down } from './icon_chevron_down.svg?react'
export { default as chevron_left } from './icon_chevron_left.svg?react'
export { default as chevron_right } from './icon_chevron_right.svg?react'
export { default as chevron_up } from './icon_chevron_up.svg?react'
export { default as circle } from './icon_circle.svg?react'
export { default as clock } from './icon_clock.svg?react'
export { default as clock_outlined } from './icon_clock_outlined.svg?react'
export { default as close } from './icon_close.svg?react'
export { default as close_circle } from './icon_close_circle.svg?react'
export { default as communication } from './icon_communication.svg?react'
export { default as content_cut } from './icon_content_cut.svg?react'
export { default as copy } from './icon_copy.svg?react'
export { default as delete } from './icon_delete.svg?react'
export { default as description_paper } from './icon_description_paper.svg?react'
export { default as done_all } from './icon_done_all.svg?react'
export { default as download } from './icon_download.svg?react'
export { default as dropdown_arrow_down } from './icon_dropdown_arrow_down.svg?react'
export { default as dropdown_arrow_right } from './icon_dropdown_arrow_right.svg?react'
export { default as dropdown_arrow_up } from './icon_dropdown_arrow_up.svg?react'
export { default as edit } from './icon_edit.svg?react'
export { default as edit_note } from './icon_edit_note.svg?react'
export { default as erase } from './icon_erase.svg?react'
export { default as events } from './icon_events.svg?react'
export { default as eye_closed } from './icon_eye_closed.svg?react'
export { default as eye_opened } from './icon_eye_opened.svg?react'
export { default as failure } from './icon_failure.svg?react'
export { default as file } from './icon_file.svg?react'
export { default as filter } from './icon_filter.svg?react'
export { default as folder_line } from './icon_folder_line.svg?react'
export { default as headset_mic } from './icon_headset_mic.svg?react'
export { default as help } from './icon_help.svg?react'
export { default as help_fill } from './icon_help_fill.svg?react'
export { default as help_line } from './icon_help_line.svg?react'
export { default as high_light } from './icon_high_light.svg?react'
export { default as hwp } from './icon_hwp.svg?react'
export { default as info } from './icon_info.svg?react'
export { default as info_fill } from './icon_info_fill.svg?react'
export { default as inside_point } from './icon_inside_point.svg?react'
export { default as keyboard } from './icon_keyboard.svg?react'
export { default as laboratory } from './icon_laboratory.svg?react'
export { default as line_add_circle } from './icon_line_add_circle.svg?react'
export { default as list } from './icon_list.svg?react'
export { default as lock_fill } from './icon_lock-fill.svg?react'
export { default as logo_block } from './icon_logo_block.svg?react'
export { default as mail } from './icon_mail.svg?react'
export { default as mail_opened } from './icon_mail_opened.svg?react'
export { default as marking } from './icon_marking.svg?react'
export { default as mathflat } from './icon_mathflat.svg?react'
export { default as memo_active } from './icon_memo-active.svg?react'
export { default as memo_default } from './icon_memo-default.svg?react'
export { default as message } from './icon_message.svg?react'
export { default as monitoring } from './icon_monitoring.svg?react'
export { default as more_veritcal } from './icon_more_veritcal.svg?react'
export { default as move } from './icon_move.svg?react'
export { default as mylist } from './icon_mylist.svg?react'
export { default as mylist_fill } from './icon_mylist_fill.svg?react'
export { default as navigation } from './icon_navigation.svg?react'
export { default as navigation_arrow_right } from './icon_navigation_arrow_right.svg?react'
export { default as navigation_arrow_back } from './icon_navigation-arrow_back.svg?react'
export { default as navigation_lower_rank } from './icon_navigation-lower-rank.svg?react'
export { default as new_tag } from './icon_new_tag.svg?react'
export { default as new_tag_orange } from './icon_new_tag_orange.svg?react'
export { default as notification } from './icon_notification.svg?react'
export { default as icon_open_width } from './icon_open_width.svg?react'
export { default as outlined_upload } from './icon_outlined_upload.svg?react'
export { default as palette } from './icon_palette.svg?react'
export { default as papers } from './icon_papers.svg?react'
export { default as pause } from './icon_pause.svg?react'
export { default as pen } from './icon_pen.svg?react'
export { default as people } from './icon_people.svg?react'
export { default as person } from './icon_person.svg?react'
export { default as phone } from './icon_phone.svg?react'
export { default as picture } from './icon_picture.svg?react'
export { default as pin } from './icon_pin.svg?react'
export { default as playlist_add_check } from './icon_playlist_add_check.svg?react'
export { default as premium_student_app } from './icon_premium_student_app.svg?react'
export { default as icon_preveal_answer } from './icon_preveal_answer.svg?react'
export { default as preview } from './icon_preview.svg?react'
export { default as print } from './icon_print.svg?react'
export { default as profile } from './icon_profile.svg?react'
export { default as purchase } from './icon_purchase.svg?react'
export { default as redo } from './icon_redo.svg?react'
export { default as refresh } from './icon_refresh.svg?react'
export { default as remove } from './icon_remove.svg?react'
export { default as remove_circle } from './icon_remove_circle.svg?react'
export { default as remove_fill } from './icon_remove_fill.svg?react'
export { default as remove_line } from './icon_remove_line.svg?react'
export { default as repeat } from './icon_repeat.svg?react'
export { default as report } from './icon_report.svg?react'
export { default as report_notification } from './icon_report_notification.svg?react'
export { default as reset } from './icon_reset.svg?react'
export { default as return } from './icon_return.svg?react'
export { default as search } from './icon_search.svg?react'
export { default as settings } from './icon_settings.svg?react'
export { default as share } from './icon_share.svg?react'
export { default as shopping_bag_fill } from './icon_shopping_bag_fill.svg?react'
export { default as skip_back } from './icon_skip_back.svg?react'
export { default as skip_forward } from './icon_skip_forward.svg?react'
export { default as swap } from './icon_swap.svg?react'
export { default as swap_horiz } from './icon_swap_horiz.svg?react'
export { default as thumb_down } from './icon_thumb_down.svg?react'
export { default as thumb_up } from './icon_thumb_up.svg?react'
export { default as timer } from './icon_timer.svg?react'
export { default as undo } from './icon_undo.svg?react'
export { default as unlock } from './icon_unlock_line.svg?react'
export { default as up_down_filter } from './icon_up_down_filter.svg?react'
export { default as upload } from './icon_upload.svg?react'
export { default as whale } from './icon_whale.svg?react'
export { default as zoom_in } from './icon_zoom_in.svg?react'
export { default as check_2 } from './worksheet_option/check_2.svg?react'
export { default as check_4 } from './worksheet_option/check_4.svg?react'
export { default as check_6 } from './worksheet_option/check_6.svg?react'
export { default as check_default } from './worksheet_option/check_default.svg?react'
export { default as uncheck_2 } from './worksheet_option/uncheck_2.svg?react'
export { default as uncheck_4 } from './worksheet_option/uncheck_4.svg?react'
export { default as uncheck_6 } from './worksheet_option/uncheck_6.svg?react'
export { default as uncheck_default } from './worksheet_option/uncheck_default.svg?react'
